import type { NewsItem } from "./types";

export const newsList: NewsItem[] = [
  {
    id: "n01",
    title: "《星海列车》第二季正式定档 12 月，全新预告公开星空之外的新站台",
    summary:
      "官方发布第二季首支正式预告，确认将于 12 月 5 日开播，并首次曝光「终点站」的设定概念图。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20visual%2C%20vintage%20space%20train%20stopping%20at%20a%20floating%20glowing%20platform%20in%20a%20purple%20orange%20nebula%2C%20a%20girl%20in%20white%20sailor%20uniform%20looking%20up%2C%20warm%20star%20light%2C%20cinematic%20anime%20key%20visual%2C%20clean%20background%2C%20no%20text&width=800&height=500&seq=news-n01-cover-v2&orientation=landscape",
    category: "新番情报",
    author: "编辑部 · 木木",
    publishedAt: "2025-10-17",
    readCount: 18420,
    isHeadline: true,
    relatedAnimeIds: ["a01"],
    tags: ["星海列车", "第二季", "定档"],
    content: [
      { type: "paragraph", text: "等了整整一年的消息终于来了。10 月 17 日晚，云间动画制作与官方社交账号同步公布了《星海列车》第二季的首支正式预告，并确认新一季将于 12 月 5 日起每周五更新，全 12 话。" },
      { type: "paragraph", text: "预告片时长 1 分 42 秒，从前一季结尾那列驶入空白星域的列车开始。在预告中，雾子第一次穿上了正式的乘务员制服，而一直沉默的列车长也终于开口说出了自己的名字。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Anime%20scene%20still%2C%20interior%20of%20a%20vintage%20train%20carriage%20with%20warm%20brass%20lamps%20and%20large%20windows%20showing%20a%20colorful%20nebula%20outside%2C%20two%20characters%20sitting%20across%20each%20other%20at%20a%20table%2C%20cinematic%20anime%20background%20art%2C%20warm%20lighting&width=1200&height=675&seq=news-n01-img1-v2&orientation=landscape", caption: "第二季概念图：车厢内侧新增了大面积观景窗" },
      { type: "subtitle", text: "「终点站」究竟是什么" },
      { type: "paragraph", text: "本次预告中最引人注意的是一个新概念：终点站。官方美术团队在采访中提到，终点站并不是某一个具体的地点，而是「所有乘客都想去的地方」。这意味着第二季的主线将从单元故事转向一条更完整的旅程叙事。" },
      { type: "paragraph", text: "导演柏木遥在寄语中表示，第二季会保留单元剧的温度，但会增加角色之间的连续性：「第一季是上车，第二季是学会在车上生活。」" },
      { type: "quote", text: "「如果终点真的存在，那希望它是每一个乘客都能再见到想见的人的地方。」—— 导演 柏木遥" },
      { type: "paragraph", text: "另外，官方确认第一季的作曲三轮光太将继续负责配乐，并会新增一支由真实手风琴演奏者录制的主题曲。第二季的片头将由乐队「夜航」演唱。" },
      { type: "paragraph", text: "对于第一季还没看过的观众，官方同步上线了第一季的回顾合集，包含 3 集精华剪辑，可以在正式开播前快速补齐剧情。" },
    ],
  },
  {
    id: "n02",
    title: "国产动画《剑起长安》开播两周口碑走高，水墨剑斗成讨论焦点",
    summary:
      "上线两周播放量破亿，第七话的「泼墨决战」单集在社交平台被反复讨论，成为本季度国产动画话题之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20animation%20news%20visual%2C%20ink%20wash%20swordsman%20swinging%20a%20sword%20with%20splashing%20black%20ink%20and%20orange%20sparks%2C%20ancient%20temple%20roof%20background%2C%20dramatic%20contrast%2C%20painterly%20texture%2C%20no%20text&width=800&height=500&seq=news-n02-cover-v2&orientation=landscape",
    category: "行业动态",
    author: "编辑部 · 陈默",
    publishedAt: "2025-10-15",
    readCount: 15260,
    isHeadline: true,
    relatedAnimeIds: ["a05", "a10"],
    tags: ["剑起长安", "国产动画", "口碑"],
    content: [
      { type: "paragraph", text: "自 10 月 1 日开播以来，《剑起长安》用两周时间完成了从「小众期待」到「季度话题」的转变。上线两周累计播放量突破一亿，社交平台相关话题阅读量超过八亿。" },
      { type: "paragraph", text: "被讨论最多的是第七话的决战段落。这一集使用了长达 40 秒的无剪辑长镜头，配合泼墨特效与实景感的光影，把「剑意」这一抽象概念做成了可以在屏幕上看到的东西。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Chinese%20animation%20scene%20still%2C%20a%20young%20swordsman%20mid%20swing%20in%20a%20rainy%20ancient%20courtyard%2C%20black%20ink%20splashes%20trailing%20the%20blade%2C%20warm%20orange%20lantern%20light%20reflecting%20on%20wet%20stone%2C%20cinematic%20painterly%20background&width=1200&height=675&seq=news-n02-img1-v2&orientation=landscape", caption: "第七话名场面：雨中泼墨决战" },
      { type: "subtitle", text: "美术团队的三年准备" },
      { type: "paragraph", text: "美术总监陈墨白在映后交流中提到，团队为这部作品做了三年的视觉开发，其中包括两次前往敦煌采风，以及一项专门为水墨渲染开发的自研工具。「最难的不是让水墨动起来，而是让它在动的过程中还保留笔触。」" },
      { type: "paragraph", text: "制作方长歌动画此前以短片与广告为主，《剑起长安》是其首部 26 集长片作品。团队规模从立项时的 40 人扩展到后期的 130 人。" },
      { type: "subtitle", text: "观众的评价集中在哪" },
      { type: "paragraph", text: "从社交平台的讨论来看，好评主要集中在美术、配乐与动作分镜三方面；争议则集中在第八话的叙事节奏，部分观众认为中段推进稍慢。制作组回应称，后半程会逐步收束到主角与师父的主线上。" },
      { type: "paragraph", text: "目前该作在平台评分稳定在 9.1 左右，已确认有海外发行计划，日文版正在制作中。" },
    ],
  },
  {
    id: "n03",
    title: "《雾港疑案》剧场版公布，故事将回到 30 年前的雾港",
    summary:
      "电视动画完结一年后，官方宣布剧场版启动，主角久住诚将以青年时期登场，揭开白船之谜的最初一层。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20movie%20teaser%20visual%2C%20a%20mysterious%20white%20ship%20emerging%20from%20dense%20fog%20at%20a%20harbor%20pier%20at%20night%2C%20single%20amber%20lamp%2C%20muted%20teal%20and%20grey%20tones%2C%20cinematic%20noir%20anime%20illustration%2C%20no%20text&width=800&height=500&seq=news-n03-cover-v2&orientation=landscape",
    category: "剧场版",
    author: "编辑部 · 松野",
    publishedAt: "2025-10-12",
    readCount: 11380,
    isHeadline: false,
    relatedAnimeIds: ["a04"],
    tags: ["雾港疑案", "剧场版", "悬疑"],
    content: [
      { type: "paragraph", text: "雾灯映画在东京举办的特别放映会上宣布，《雾港疑案》剧场版正式启动，预计于 2027 年上映。剧场版将回到电视动画故事发生的 30 年前，讲述青年久住诚第一次踏上雾港时的经历。" },
      { type: "paragraph", text: "导演重田真一表示，剧场版不是外传，而是「拼图缺失的那一块」。电视版里出现过但没解释的「白船」，将会在剧场版里给出第一个答案。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Anime%20cinematic%20still%2C%20a%20young%20detective%20looking%20at%20a%20wall%20of%20old%20photographs%20and%20newspaper%20clippings%20in%20a%20dim%20office%2C%20warm%20desk%20lamp%20light%2C%20muted%20green%20grey%20palette%2C%20noir%20atmosphere&width=1200&height=675&seq=news-n03-img1-v2&orientation=landscape", caption: "剧场版概念图：青年久住诚的调查笔记" },
      { type: "paragraph", text: "目前公布的制作阵容基本沿用电视版班底，系列构成野间绫负责剧本。音乐仍由夜雾回廊担任，并会加入完整的管弦乐编制。" },
      { type: "paragraph", text: "放映会上还播放了一段 30 秒的先导影像，画面中只有一个在雾里行走的背影，以及远处模糊的白色船影。现场观众反应相当热烈。" },
    ],
  },
  {
    id: "n04",
    title: "秋季新番中期观察：五部值得追的作品，和它们的共同特点",
    summary:
      "秋季新番已播出约四周，我们整理了目前口碑最稳的五部作品，以及它们在叙事节奏上的共同点。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20editorial%20illustration%2C%20five%20stylized%20anime%20character%20silhouettes%20standing%20in%20a%20row%20against%20a%20warm%20orange%20gradient%20background%20with%20geometric%20shapes%2C%20clean%20modern%20poster%20design%2C%20no%20text&width=800&height=500&seq=news-n04-cover-v2&orientation=landscape",
    category: "新番情报",
    author: "编辑部 · 木木",
    publishedAt: "2025-10-10",
    readCount: 22150,
    isHeadline: false,
    relatedAnimeIds: ["a01", "a02", "a09"],
    tags: ["秋季新番", "盘点", "推荐"],
    content: [
      { type: "paragraph", text: "秋季新番已经播到第四周左右，该弃的弃了，该追的也追稳了。这一季的整体素质肉眼可见地高，尤其是动作与美术层面。下面是我们编辑部内部投票出来的五部重点作品。" },
      { type: "subtitle", text: "一、《裂界武斗》：把动作做到极致" },
      { type: "paragraph", text: "如果你只看一部爽番，那没得选。它的动作密度高到几乎没有喘息空间，但难得的是每一场战斗都服务于角色关系，而不是单纯炫技。" },
      { type: "subtitle", text: "二、《星海列车》：温柔是最难的技术" },
      { type: "paragraph", text: "很多作品想做治愈，但做成了无聊。《星海列车》做对了的地方在于，它给每一集都安排了一个明确的情绪落点，而且从不急着解释。" },
      { type: "subtitle", text: "三、《破风之路》：运动番的正确打开方式" },
      { type: "paragraph", text: "今年的自行车番把「专业性」和「爽感」平衡得很好。看的时候会不自觉地屏住呼吸，这一点很难得。" },
      { type: "paragraph", text: "另外两部高分作品分别是国产的《深海图书馆》与日系的《周六的猫町咖啡》。它们共同的特点是：不依赖宏大设定，而是把一件小事讲得很认真。" },
    ],
  },
  {
    id: "n05",
    title: "声优天野琴音谈《星海列车》：给雾子配音，像重新学一次说话",
    summary: "在官方访谈中，天野琴音聊了自己对雾子这个角色的理解，以及录制第一季最终话时的情形。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20interview%20editorial%20visual%2C%20a%20recording%20studio%20with%20a%20vintage%20microphone%20and%20script%20pages%2C%20warm%20amber%20light%2C%20empty%20chair%20in%20frame%2C%20soft%20focus%2C%20no%20people%2C%20clean%20background%2C%20no%20text&width=800&height=500&seq=news-n05-cover-v2&orientation=landscape",
    category: "声优动态",
    author: "编辑部 · 铃木",
    publishedAt: "2025-10-08",
    readCount: 8640,
    isHeadline: false,
    relatedAnimeIds: ["a01"],
    tags: ["天野琴音", "声优", "星海列车"],
    content: [
      { type: "paragraph", text: "在《星海列车》第一季一周年纪念活动上，为雾子配音的天野琴音接受了官方媒体的采访。她提到，接到这个角色时自己刚出道不久，「每天都在重新学怎么把一句话说得更轻一点」。" },
      { type: "quote", text: "「导演跟我说，雾子说话就像怕吵醒别人。这句话我记了很久。」" },
      { type: "paragraph", text: "谈到第一季最终话，她表示那一集录制了整整六个小时，其中最后两句台词反复录了二十多遍。「不是因为不满意，是因为每次都会哭，声音会抖。」" },
      { type: "paragraph", text: "对于第二季，她卖了个关子：「雾子会变成更主动的人。以前她总是等别人开口，这次她先说话。」" },
      { type: "paragraph", text: "顺带一提，她本人也是手风琴爱好者，这次第二季的主题曲里有她录制的和声部分。" },
    ],
  },
  {
    id: "n06",
    title: "2025 冬日动漫展公布首批参展阵容，超过 120 家社团报名",
    summary: "漫画展区、同人社团区与动画周边区三大板块确认，早鸟票将于本月 25 日开启。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20convention%20poster%20illustration%2C%20crowded%20bright%20exhibition%20hall%20with%20booths%20and%20banners%2C%20empty%20stage%20with%20warm%20orange%20lights%2C%20clean%20graphic%20style%2C%20no%20text%2C%20no%20readable%20signage&width=800&height=500&seq=news-n06-cover-v2&orientation=landscape",
    category: "活动资讯",
    author: "编辑部 · 阿棠",
    publishedAt: "2025-10-06",
    readCount: 6210,
    isHeadline: false,
    relatedAnimeIds: ["a05", "a10"],
    tags: ["漫展", "活动", "同人"],
    content: [
      { type: "paragraph", text: "2025 冬日动漫展主办方今日公布了首批参展阵容。官方表示，本届展会报名社团数量已超过 120 家，较去年增长约三成，展区总面积也扩大到原来的 1.5 倍。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Anime%20exhibition%20hall%20interior%2C%20bright%20daylight%20through%20glass%20roof%2C%20rows%20of%20empty%20booths%20being%20set%20up%2C%20warm%20wood%20and%20white%20color%20scheme%2C%20clean%20modern%20convention%20architecture%2C%20no%20people%2C%20no%20text&width=1200&height=675&seq=news-n06-img1-v2&orientation=landscape", caption: "展会现场搭建进度，主办方供图" },
      { type: "paragraph", text: "本届展会分为漫画展区、同人社团区、动画周边区三大板块。其中动画周边区将首次设置「制作现场展示」环节，邀请两部国产动画的美术团队现场演示分镜绘制。" },
      { type: "paragraph", text: "早鸟票将于 10 月 25 日开启预售，普通单日票与三日通票同期开放。主办方提示，往年的周末场次通常会提前售罄，建议提前购票。" },
      { type: "paragraph", text: "完整参展名单与现场活动日程将在 11 月初公布。" },
    ],
  },
  {
    id: "n07",
    title: "《深海图书馆》第七话：一本没有作者的书，和一段被藏起来的告别",
    summary: "第七话用一本「无名之书」讲了全书最安静的一集，播出后相关讨论量大幅上涨。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20scene%20still%2C%20underwater%20library%20aisle%20with%20floating%20open%20book%20glowing%20warm%20amber%2C%20deep%20teal%20water%20light%2C%20fish%20silhouettes%2C%20cinematic%20fantasy%20anime%20art%2C%20quiet%20melancholic%20mood%2C%20no%20text&width=800&height=500&seq=news-n07-cover-v2&orientation=landscape",
    category: "行业动态",
    author: "编辑部 · 陈默",
    publishedAt: "2025-10-03",
    readCount: 9480,
    isHeadline: false,
    relatedAnimeIds: ["a10"],
    tags: ["深海图书馆", "第七话", "国产动画"],
    content: [
      { type: "paragraph", text: "《深海图书馆》第七话播出后，讨论热度明显上升。这一集几乎没有动作场面，场景也只有一个书库走廊，却成了目前评分最高的一集。" },
      { type: "paragraph", text: "本集的核心是一本没有作者的书。小舟在整理书架时发现，这本书每一页都只写着一句话：「今天他也没有来。」" },
      { type: "quote", text: "「有些故事不是没人写，是写的人不知道该怎么结尾。」—— 第七话台词" },
      { type: "paragraph", text: "谜底并不复杂，但解法相当温柔。当小舟把这本书放回正确的位置，书架尽头的那扇窗亮了一下，观众才意识到这其实是一段跨越六十年的告别。" },
      { type: "paragraph", text: "导演沈知白在社交平台上表示，这一集的分镜做了七版，最后选择了最静的一种。「我们想试试看，能不能让观众在没有任何刺激的情况下，安静地哭一次。」" },
    ],
  },
  {
    id: "n08",
    title: "《机械师与花》重制版上线，新增两集未播出内容",
    summary: "老式机器人 T-07 的故事补完，新增两集讲述它的「第一天」与「最后一天」。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20still%2C%20a%20small%20round%20vintage%20robot%20holding%20a%20potted%20orange%20flower%20in%20a%20sunlit%20workshop%2C%20brass%20gears%20and%20wood%20shelves%20in%20background%2C%20warm%20amber%20cream%20palette%2C%20detailed%20anime%20illustration%2C%20no%20text&width=800&height=500&seq=news-n08-cover-v2&orientation=landscape",
    category: "新番情报",
    author: "编辑部 · 铃木",
    publishedAt: "2025-09-29",
    readCount: 7420,
    isHeadline: false,
    relatedAnimeIds: ["a08"],
    tags: ["机械师与花", "重制版", "补完"],
    content: [
      { type: "paragraph", text: "《机械师与花》的导演剪辑重制版于本周上线，除了画面修复与音轨重新混音之外，最大惊喜是新增的两集内容，合计约 44 分钟。" },
      { type: "paragraph", text: "新增内容分别讲述 T-07 的「第一天」（它为什么会被制造出来）与「最后一天」（花终于开的那天之后发生了什么）。" },
      { type: "paragraph", text: "导演木户彩花在导语中写道：「电视版是库玛的故事，这次想补上 T-07 自己的部分。」" },
      { type: "paragraph", text: "对于喜欢原作的观众，这次重制版值得再看一遍；如果是第一次接触，也可以直接从重制版开始。" },
    ],
  },
  {
    id: "n09",
    title: "制作公司云间动画宣布扩大产能，明年将同时推进三部作品",
    summary: "在完成《星海列车》第二季后，云间动画计划开启一条新的原创企划线。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20studio%20illustration%2C%20bright%20animation%20studio%20workspace%20with%20drawing%20tables%20and%20screens%20showing%20character%20sketches%2C%20warm%20daylight%2C%20clean%20minimal%20interior%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=news-n09-cover-v2&orientation=landscape",
    category: "行业动态",
    author: "编辑部 · 松野",
    publishedAt: "2025-09-24",
    readCount: 5380,
    isHeadline: false,
    relatedAnimeIds: ["a01", "a06"],
    tags: ["云间动画", "制作公司", "产能"],
    content: [
      { type: "paragraph", text: "云间动画今日宣布完成新一轮组织调整，制作部门扩大至原来的两倍，并新设一个原创企划工作室。明年将同时推进三部作品，其中一部为完全原创。" },
      { type: "paragraph", text: "公司代表在说明会上表示，扩编的主要目的是「让每一部作品都有足够的准备时间」，而不是简单地增加产量。" },
      { type: "paragraph", text: "业内分析认为，这一调整与近年来动画制作周期紧张的整体状况有关。越来越多工作室开始通过内部培养与中期产能规划来缓解压力。" },
      { type: "paragraph", text: "原创企划的详细信息预计将在明年春天公布。" },
    ],
  },
  {
    id: "n10",
    title: "《破风之路》最终话特辑：那一场爬坡，其实拍了四个月",
    summary: "动画团队公开最终话的制作花絮，从分镜到作画监督的修改过程都被完整记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Animation%20production%20feature%2C%20hand%20drawn%20key%20animation%20frames%20of%20a%20cyclist%20climbing%20a%20steep%20mountain%20road%20pinned%20on%20a%20board%2C%20warm%20desk%20lamp%20light%2C%20clean%20workspace%2C%20no%20text&width=800&height=500&seq=news-n10-cover-v2&orientation=landscape",
    category: "行业动态",
    author: "编辑部 · 阿棠",
    publishedAt: "2025-09-18",
    readCount: 6890,
    isHeadline: false,
    relatedAnimeIds: ["a09"],
    tags: ["破风之路", "制作花絮", "运动番"],
    content: [
      { type: "paragraph", text: "《破风之路》官方频道上线了一支 18 分钟的制作特辑，聚焦最终话那场长达 6 分钟的爬坡戏。" },
      { type: "paragraph", text: "据作画监督介绍，这场戏的分镜修改了十一稿，仅最终冲刺部分的原画就超过 400 张。团队甚至请来了真实的公路车选手参与动作参考录制。" },
      { type: "paragraph", text: "特辑中还出现了导演岩下润的一段话：「运动番最怕的是观众看不出累。所以我们在每一次踩踏里，都放了角色的呼吸。」" },
      { type: "paragraph", text: "特辑上线一天内播放量突破两百万，官方表示若反响良好，会考虑推出完整版幕后纪录片。" },
    ],
  },
  {
    id: "n11",
    title: "《银月食堂》推出联动食谱，收录剧中 12 道家常菜",
    summary: "官方与出版社合作的联动食谱即将上市，完整还原剧中每一集出现的那道菜的做法。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20food%20editorial%20visual%2C%20open%20cookbook%20on%20a%20warm%20wooden%20kitchen%20counter%20with%20a%20bowl%20of%20miso%20soup%20and%20a%20soft%20boiled%20egg%2C%20steam%20rising%2C%20warm%20amber%20cream%20palette%2C%20cozy%20photography%20style%2C%20no%20text&width=800&height=500&seq=news-n11-cover-v2&orientation=landscape",
    category: "活动资讯",
    author: "编辑部 · 阿棠",
    publishedAt: "2025-09-14",
    readCount: 4820,
    isHeadline: false,
    relatedAnimeIds: ["a13"],
    tags: ["银月食堂", "联动", "食谱"],
    content: [
      { type: "paragraph", text: "《银月食堂》官方今日宣布，将与出版社合作推出联动食谱，收录电视动画中出现的 12 道家常菜，预计 11 月中旬发售。" },
      { type: "paragraph", text: "食谱由动画的食物作画参考团队参与监修，不仅收录做法，还附上了每一集对应的场景分镜与角色台词。" },
      { type: "paragraph", text: "官方表示，考虑到部分食材在现实中不易获取，食谱为每道菜都准备了替代方案。「希望读者能在自己家的厨房里，做出那一碗汤。」" },
      { type: "paragraph", text: "同日起，东京两家合作餐厅将推出限量联动菜单，持续三周。" },
    ],
  },
  {
    id: "n12",
    title: "《零号档案》结局解析：那场「不存在的事故」究竟意味着什么",
    summary: "最终话播出后，关于结局的解读在社交平台上持续发酵。我们从三个细节出发聊一聊。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20analysis%20editorial%20visual%2C%20scattered%20old%20documents%20and%20photographs%20on%20a%20dark%20desk%20under%20a%20single%20warm%20lamp%2C%20a%20magnifying%20glass%2C%20muted%20charcoal%20and%20amber%20tones%2C%20cinematic%20still%20life%2C%20no%20text&width=800&height=500&seq=news-n12-cover-v2&orientation=landscape",
    category: "行业动态",
    author: "编辑部 · 陈默",
    publishedAt: "2025-09-06",
    readCount: 10320,
    isHeadline: false,
    relatedAnimeIds: ["a14"],
    tags: ["零号档案", "结局", "解析"],
    content: [
      { type: "paragraph", text: "《零号档案》最终话播出后，讨论热度远超预期。这个结局没有给出一个明确的答案，但它把前面的所有线索都指向了同一个方向。" },
      { type: "subtitle", text: "细节一：门禁记录的时间差" },
      { type: "paragraph", text: "第三话中老吴提到的门禁记录，在最终话里再次出现。仔细看的话，那天晚上的记录比实际时间少了一分钟——正好是事故发生的时长。" },
      { type: "subtitle", text: "细节二：苏期的笔记本" },
      { type: "paragraph", text: "她从第一集开始就在写同一本笔记，而最终话里那本笔记的封面数字变了。这个镜头的处理非常轻，但基本确认了观众最想知道的那个猜测。" },
      { type: "subtitle", text: "细节三：最后一句话" },
      { type: "paragraph", text: "「档案不会说谎，但记录会。」这句话在第一集和最终话各出现了一次，前后语气完全不同。这也是本作最精彩的一次呼应。" },
    ],
  },
  {
    id: "n13",
    title: "《第七声铃》重播版上线，新增 4 分钟尾声片段",
    summary: "重播版本在最终话后追加了一段尾声，讲述十年后的那所学校。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20nostalgic%20still%2C%20old%20school%20bell%20tower%20seen%20from%20a%20distance%20at%20sunset%2C%20overgrown%20courtyard%2C%20warm%20orange%20light%20and%20long%20shadows%2C%20soft%20melancholic%20anime%20background%20art%2C%20no%20text&width=800&height=500&seq=news-n13-cover-v2&orientation=landscape",
    category: "新番情报",
    author: "编辑部 · 松野",
    publishedAt: "2025-08-21",
    readCount: 5940,
    isHeadline: false,
    relatedAnimeIds: ["a16"],
    tags: ["第七声铃", "重播", "尾声"],
    content: [
      { type: "paragraph", text: "《第七声铃》重播版于本周上线，最终话后追加了一段约 4 分钟的尾声，讲述故事结束十年后的旧校舍。" },
      { type: "paragraph", text: "这段尾声没有台词，只有空荡荡的走廊、风吹动的窗帘，以及钟楼在黄昏时轻轻响了一下。" },
      { type: "paragraph", text: "导演户田直人在留言中写道：「当年没能放进正片，是因为怕破坏那个停下来的瞬间。现在觉得，也许观众需要一个可以走出来的出口。」" },
      { type: "paragraph", text: "重播版同期上线了修复后的画面，色彩比原版更接近最初的设定稿。" },
    ],
  },
];